import { useQuery } from '@apollo/client';

import { Targeted_USERS } from '../graphql/query/targetedUsersQuery.graphql';

export const useTargetedUsersQuery = (eventId: string) => {
  return useQuery(Targeted_USERS, {
    variables: { eventId },
    fetchPolicy: 'cache-and-network',
  });
};
